export const text = {
    // TODO: localize
    members: `Members`,
    teams: `Teams`,
};
